// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2HTeD","blue":"Button_blue__-rPhc","gray":"Button_gray__fd0VR","red":"Button_red__8Igcr"};